import { render, staticRenderFns } from "./update-config.vue?vue&type=template&id=d4ed7138&scoped=true&"
import script from "./update-config.vue?vue&type=script&lang=js&"
export * from "./update-config.vue?vue&type=script&lang=js&"
import style0 from "./update-config.vue?vue&type=style&index=0&id=d4ed7138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ed7138",
  null
  
)

export default component.exports